import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=179d81c5&scoped=true"
var script = {}
import style0 from "./Edit.vue?vue&type=style&index=0&id=179d81c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d81c5",
  null
  
)

export default component.exports